module.exports = __webpack_public_path__ + "logo-icon.png?ede1dca5a6d0dd40a5ac9f6cdf6e3d77";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-icon.png
// module id = 1210
// module chunks = 2